import api from '../../utils/api';

export type ServiceType =
  | 'AMBULANCE'
  | 'BLOOD_BANK'
  | 'MEDICINE'
  | 'LAB_TEST'
  | 'CLINIC'
  | 'GENERAL_APP';
export type TargetType = 'VENDOR' | 'DELIVERY_PARTNER' | 'APP' | 'SUPPORT';
export type ActorType = 'USER' | 'VENDOR';
export type FeedbackStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export interface FeedbackRow {
  feedbackId: string;
  userId: string;
  serviceType: ServiceType;
  referenceId: string | null;
  targetType: TargetType;
  targetId: string | null;
  rating: number;
  ratingBreakdown: Record<string, number> | null;
  review: string | null;
  fileUrls: string[] | null;
  status: FeedbackStatus;
  createdAt: string;
  updatedAt: string;
  submitterName: string;
  submitterPhone: string;
  actorType: ActorType | null;
  vendorType?: string | null;
  vendorTypeLabel?: string | null;
  vendorKind?: string | null;
  submitterProfilePath?: string | null;
}

export interface GetFeedbacksParams {
  limit?: number;
  offset?: number;
  serviceType?: ServiceType;
  targetType?: TargetType;
  targetId?: string;
  status?: FeedbackStatus;
  actorType?: ActorType;
  search?: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface GetFeedbacksResponse {
  success: boolean;
  data: FeedbackRow[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
  };
}

export async function getFeedbacks(params: GetFeedbacksParams = {}): Promise<GetFeedbacksResponse> {
  const searchParams = new URLSearchParams();
  if (params.limit != null) searchParams.set('limit', String(params.limit));
  if (params.offset != null) searchParams.set('offset', String(params.offset));
  if (params.serviceType) searchParams.set('serviceType', params.serviceType);
  if (params.targetType) searchParams.set('targetType', params.targetType);
  if (params.targetId) searchParams.set('targetId', params.targetId);
  if (params.status) searchParams.set('status', params.status);
  if (params.actorType) searchParams.set('actorType', params.actorType);
  if (params.search) searchParams.set('search', params.search);
  if (params.dateFrom) searchParams.set('dateFrom', params.dateFrom);
  if (params.dateTo) searchParams.set('dateTo', params.dateTo);
  const qs = searchParams.toString();
  const url = `/master-admin/feedbacks${qs ? `?${qs}` : ''}`;
  const response = await api.get<GetFeedbacksResponse>(url);
  return response.data;
}

export async function updateFeedbackStatus(
  feedbackId: string,
  status: FeedbackStatus
): Promise<{ success: boolean; message: string; data: FeedbackRow }> {
  const response = await api.patch<{ success: boolean; message: string; data: FeedbackRow }>(
    `/master-admin/feedbacks/${feedbackId}/status`,
    { status }
  );
  return response.data;
}

export function canApproveForProviderProfile(row: FeedbackRow): boolean {
  return row.actorType === 'USER' && row.targetType === 'VENDOR' && Boolean(row.targetId);
}

export function statusLabel(status: FeedbackStatus): string {
  if (status === 'APPROVED') return 'On profile';
  if (status === 'REJECTED') return 'Rejected';
  return 'Pending';
}
